var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jobSelectModalContainer"},[_c('Presentational',{attrs:{"jobList":_vm.jobList},on:{"close":function($event){return _vm.$emit('modalClose')},"entry":function (payload) { return _vm.addSkills(payload); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }